import { z } from "zod";

export const BIO_TEXT_MAX = 150;

const bioTextSchema = z.string().min(1).max(BIO_TEXT_MAX);

export const BioContentSchema = z.discriminatedUnion("kind", [
  z.object({
    kind: z.literal("custom"),
    text: bioTextSchema,
  }),
  z.object({
    kind: z.literal("preset"),
    presetId: z.string().min(1),
    text: bioTextSchema,
  }),
  z.object({
    kind: z.literal("qa"),
    questionId: z.string().min(1),
    question: z.string().min(1),
    answer: bioTextSchema,
  }),
]);

export type BioContent = z.infer<typeof BioContentSchema>;

export function flattenBio(content: BioContent): string {
  return content.kind === "qa" ? content.answer : content.text;
}

export function resolveBioContent(input: {
  bio?: string | null | undefined;
  bioContent?: BioContent | null | undefined;
}): BioContent | null {
  if (input.bioContent) {
    const parsed = BioContentSchema.safeParse(input.bioContent);
    if (parsed.success) {
      return parsed.data;
    }
  }
  const legacy = input.bio?.trim();
  if (legacy) {
    return { kind: "custom", text: legacy.slice(0, BIO_TEXT_MAX) };
  }
  return null;
}
